import React, { useState } from 'react';
import { Message, MessagePurpose, MessageType } from '@lux/message';
import { Translate, useFormatters } from '@pegasus/translation';
import { IconSize, Information, PlusMonogram } from '@lux/icons';
import { Preset, Text } from '@lux/text';
import { FreeDeliveryTermsConditionsDialog } from '@client/components/mylounge/plus/benefits/free-delivery/terms-conditions-dialog';
import { ONE_DAY, setCookie } from '@client/helpers/cookie';
import { FREE_DELIVERY_BANNER_COOKIE } from '@client/components/mylounge/constants';
import { useUnlimitedFreeDelivery } from '@client/components/mylounge/plus/use-unlimited-free-delivery';
import { DarkModeProvider } from '@lux/core';

type UnlimitedFreeDeliveryBannerProps = {
    onClose: () => void;
};

export const UnlimitedFreeDeliveryBanner = ({ onClose }: UnlimitedFreeDeliveryBannerProps) => {
    const { formatPrice } = useFormatters();
    const [openTC, setOpenTC] = useState(false);
    const { month, minimumOrderValue } = useUnlimitedFreeDelivery();

    const onCloseHandler = () => {
        setCookie(FREE_DELIVERY_BANNER_COOKIE, 'true', ONE_DAY * 7);
        onClose();
    };

    const onTCOpenHandler = () => {
        setOpenTC(true);
    };

    const onTCCloseHandler = () => {
        setOpenTC(false);
    };

    return (
        <DarkModeProvider>
            <Message
                type={MessageType.BANNER}
                // @ts-expect-error
                purpose={MessagePurpose.FEATURE}
                icon={<PlusMonogram size={24} />}
                onClose={onCloseHandler}
                className="bg-brand-loyalty shadow-none"
            >
                <Text
                    preset={Preset.S}
                    className="text-function-0 cursor-pointer"
                    onClick={onTCOpenHandler}
                >
                    <Translate
                        message="free_delivery.unlimited.header_banner"
                        params={{
                            minimumOrderValue: formatPrice({
                                cents: minimumOrderValue * 100,
                                maximumFractionDigits: 0,
                            }),
                            month,
                        }}
                        raw
                    />
                    <Information className="ml-xxs" size={IconSize.XS} />
                </Text>
            </Message>
            <FreeDeliveryTermsConditionsDialog open={openTC} onBack={onTCCloseHandler} />
        </DarkModeProvider>
    );
};
